const browserAgent = ( function checkBrowser(){

    const userAgent=navigator?.userAgent?.toLowerCase();

    const isChrome=userAgent?.includes('chrome');

    const isSafari= !isChrome && userAgent?.includes('safari');


    return { isChrome, isSafari };
} )();


export default browserAgent ;